import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Tooltip from '@material-ui/core/Tooltip';
import { lighten } from '@material-ui/core/styles/colorManipulator';
import withUser from '../HOC/HOCwithUser.jsx';
import { Redirect, withRouter } from 'react-router-dom';
import HOCLoader from '../HOC/HOCLoader.jsx';
import { connect } from 'react-redux';
import { compose } from 'redux';
import * as actions from '../../actions';
import withCustomTheme from '../HOC/HOCwithCustomTheme.jsx';
import { Button } from '@material-ui/core';
import { FormattedMessage, injectIntl } from 'react-intl';
import moment from 'moment';
import AddIcon from '@material-ui/icons/Add';
import AddWalletMoneyForm from '../Customer/AddWalletMoneyForm.jsx';
import Axios from 'axios';
import { SERVER_URL, ROLE_CUSTOMER } from '../../utils/config/constants.js';
import { getCookies } from '../../utils/getToken.js';
function desc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
    return order === 'desc'
        ? (a, b) => desc(a, b, orderBy)
        : (a, b) => -desc(a, b, orderBy);
}

class WalletListHead extends React.Component {
    createSortHandler = property => event => {
        this.props.onRequestSort(event, property);
    };

    render() {
	    let rows = [];
	    if(this.props.userRole == ROLE_CUSTOMER) {
		    rows = [
                {
                    id: 'CreditType',
                    label: 'Type'
                },
                {
                    id: 'BookingNumber',
                    label: 'Booking Number'
                },
                {
                    id: 'Amount',
                    label: 'Amount'
                },
                // {
				//     id: 'BookingId',
				//     label: this.props.formatMessage({
				// 	    id: 'wallet.BookingId'
				//     })
			    // },
                // {
				//     id: 'amount',
				//     label: this.props.formatMessage({
				// 	    id: 'wallet.amount'
				//     })
			    // },
			    // {
				//     id: 'closing_balance',
				//     label: this.props.formatMessage({
				// 	    id: 'wallet.closingbalance'
				//     })
			    // },
			    // {
				//     id: 'heading',
				//     label: this.props.formatMessage({
				// 	    id: 'wallet.transactionheading'
				//     })
			    // },
			    // {
				//     id: 'created_at',
				//     label: this.props.formatMessage({
				// 	    id: 'wallet.created_at'
				//     })
			    // }
		    ];
	    } else {
		    rows = [
			    {
				    id: 'amount',
				    label: this.props.formatMessage({
					    id: 'wallet.amount'
				    })
			    },
                // {
				//     id: 'BOOKING_ID',
				//     label: this.props.formatMessage({
				// 	    id: 'BOOKING_ID'
				//     })
			    // },
			    {
				    id: 'heading',
				    label: this.props.formatMessage({
					    id: 'wallet.transactionheading'
				    })
			    },
			    {
				    id: 'created_at',
				    label: this.props.formatMessage({
					    id: 'wallet.created_at'
				    })
			    }
                
		    ];

	    }
        const {
            onSelectAllClick,
            order,
            orderBy,
            numSelected,
            rowCount
        } = this.props;

        return (
            <TableHead>
                <TableRow>
                    {/* <TableCell padding="checkbox">
                        <Checkbox
                            indeterminate={
                                numSelected > 0 && numSelected < rowCount
                            }
                            checked={numSelected === rowCount}
                            onChange={onSelectAllClick}
                        />
                    </TableCell> */}
                    {rows.map(
                        row => (
                            <TableCell
                                key={row.id}
                                align={row.numeric ? 'right' : 'left'}
                                padding={
                                    row.disablePadding ? 'none' : 'default'
                                }
                                sortDirection={
                                    orderBy === row.id ? order : false
                                }
                            >
                                <Tooltip
                                    title="Sort"
                                    placement={
                                        row.numeric
                                            ? 'bottom-end'
                                            : 'bottom-start'
                                    }
                                    enterDelay={300}
                                >
                                    <TableSortLabel
                                        active={orderBy === row.id}
                                        direction={order}
                                        onClick={this.createSortHandler(row.id)}
                                    >
                                        {row.label}
                                    </TableSortLabel>
                                </Tooltip>
                            </TableCell>
                        ),
                        this
                    )}
                </TableRow>
            </TableHead>
        );
    }
}

WalletListHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired
};

const toolbarStyles = theme => ({
    root: {
        paddingRight: theme.spacing.unit
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85)
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.secondary.dark
            },
    spacer: {
        flex: '1 1 100%'
    },
    actions: {
        color: theme.palette.secondary.main
    },
    title: {
        flex: '0 0 auto'
    }
});

let WalletListToolbar = props => {
    const { numSelected, classes, onAddClick } = props;

    return (
        <div className=" d-flex">
            <div className={classes.title + ' ds-boar-title'}>
                {numSelected > 0 ? (
                    <Typography
                        color="inherit"
                        variant="subtitle1"
                        className="p-0"
                    >
                        {numSelected}{' '}
                        <FormattedMessage
                            id="wallet.selected"
                            defaultMessage="selected"
                        />
                    </Typography>
                ) : (
                        // <h2>
                        //     <FormattedMessage
                        //         id="wallet.heading"
                        //         defaultMessage="Wallet Transactions"
                        //     />
                        // </h2>
                        <div className='ds-boar-title'>
                            <h2 style={{
                                textAlign: 'start',
                                // color: '#0078ff',
                                marginTop: 20
                            }}>
                                <FormattedMessage
                                    id="wallet.heading"
                                    defaultMessage="Wallet Transactions"
                                />
                            </h2>
                        </div>
                    )}
            </div>
            <div className={classes.spacer} />
            {/* {props.userData.role == ROLE_CUSTOMER &&
                <div className={classes.actions}>
                    <Tooltip title="Add">
                        <Button
                            variant="fab"
                            color="primary"
                            aria-label="Add"
                            onClick={onAddClick}
                        >
                            <AddIcon />
                        </Button>
                    </Tooltip>
                </div>} */}
        </div>
    );
};

WalletListToolbar.propTypes = {
    // classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    mainbalance: PropTypes.number
};

WalletListToolbar = withStyles(toolbarStyles)(WalletListToolbar);

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3
    },
    table: {
        minWidth: 700
    },
    tableWrapper: {
        overflowX: 'auto'
    }
});

class WalletList extends React.Component {
    constructor(props) {
        super();
        this.state = {
            order: 'desc',
            orderBy: 'created_at',
            selected: [],
            data: props.userData.role == ROLE_CUSTOMER ? props.transactions ? props.transactions : [] : [],
            page: 0,
            rowsPerPage: 10,
            clickValue: '',
            itemId: '',
            showCreateForm: false,
	    userRole: props.userData.role
        };
    }

    actionCallbacks(action, res) {
        if (action === 'view') {
            this.setState({ clickValue: 'view', itemId: res.key });
        } else if (action === 'update') {
            this.setState({
                clickValue: 'update',
                itemId: res.key,
                menuState: false
            });
        }
    }
    componentDidMount() {
        console.log("props.transactions", this.props.transactions);
        if (this.props.userData.role == ROLE_CUSTOMER) {
            // this.props.walletListAction();
            var authToken = getCookies();
            Axios({
                method: 'get',
                url: `${SERVER_URL}/booking/get-user-credit`,
                headers: {
                    'x-auth-Token': authToken
                }
            }).then(response => {
                if (response.data.status == 'OK') {
                    console.log("data ===============", response.data.data.transaction_details);
                    this.setState({ data: response.data.data.transaction_details })
                }
                else {
                    this.setState({ data: [] })
                }
            })
        } else {
            var authToken = getCookies();
            Axios({
                method: 'get',
                url: `${SERVER_URL}/transaction/provider`,
                headers: {
                    'x-auth-Token': authToken
                }
            }).then(response => {
                if (response.data.status == 'OK') {
                    console.log("data ===============", response);
                    this.setState({ data: response.data.data.transactions })
                }
                else {
                    this.setState({ data: [] })
                }
            })
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.props.userData.role == ROLE_CUSTOMER) {
            if (prevProps.transactions !== this.props.transactions) {
                this.setState({ data: this.props.transactions });
            }
        }
    }
    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        this.setState({ order, orderBy });
    };

    handleSelectAllClick = event => {
        if (event.target.checked) {
            this.setState(state => ({ selected: state.data.map(n => n.key) }));
            return;
        }
        this.setState({ selected: [] });
    };

    handleClick = (event, id) => {
        const { selected } = this.state;
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }

        this.setState({ selected: newSelected });
    };

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };

    isSelected = id => this.state.selected.indexOf(id) !== -1;
    onAddClick = () => {
        this.setState({ showCreateForm: true });
    };
    backToList = () => {
        this.setState({ showCreateForm: false });
    };
    render() {
        const { classes } = this.props;
        const {
            data,
            order,
            orderBy,
            selected,
            rowsPerPage,
            page,
            showCreateForm
        } = this.state;
        const { formatMessage } = this.props.intl;
        const emptyRows =
            rowsPerPage -
            Math.min(rowsPerPage, data.length - page * rowsPerPage);

        if (this.state.clickValue) {
            this.props.history.push({
                pathname: `/address/${this.state.clickValue}`,
                state: { itemId: this.state.itemId }
            });
            // return (
            //     <Redirect
            //         to={{
            //             pathname: `/address/${this.state.clickValue}`,
            //             state: { itemId: this.state.itemId }
            //         }}
            //     />
            // );
        }
        if (showCreateForm) {
            return (
                <div>
                    <AddWalletMoneyForm backToList={this.backToList} />
                </div>
            );
        }

        return (
            <HOCLoader loading={this.props.walletLoader}>
                <div>
                    <WalletListToolbar
                        numSelected={selected.length}
                        balance={this.props.walletData.balance}
                        settings={this.props.settings}
                        onAddClick={this.onAddClick}
                        userData={this.props.userData}
                    />
                    <div className="tz-db-table" style={{marginTop: -30}}>
                        <Table
                            aria-labelledby="tableTitle"
                            className="table bordered"
                        >
                            <WalletListHead
                                numSelected={selected.length}
                                order={order}
                                orderBy={orderBy}
                                onSelectAllClick={this.handleSelectAllClick}
                                onRequestSort={this.handleRequestSort}
                                rowCount={data.length}
                                formatMessage={this.props.intl.formatMessage}
				                userRole={this.state.userRole}
                            />
                            <TableBody>
                                {stableSort(data, getSorting(order, orderBy))
                                    .slice(
                                        page * rowsPerPage,
                                        page * rowsPerPage + rowsPerPage
                                    )
                                    .map(n => {
                                        const isSelected = this.isSelected(
                                            n.key
                                        );
                                        return (
                                            <TableRow
                                                hover
                                                role="checkbox"
                                                aria-checked={isSelected}
                                                tabIndex={-1}
                                                key={n.key}
                                                selected={isSelected}
                                            >
                                            { data.provider == "Not Assigned" ? 
                                            null : this.props.userData.role ==
                                            ROLE_CUSTOMER &&   
                                    <React.Fragment>
                                            <TableCell>
                                            {this.state.userRole == ROLE_CUSTOMER ? n.booking_number :"-"}
                                        </TableCell>
                                        </React.Fragment>
                                            }

                                                <TableCell className="status-cell">
							{(this.state.userRole == ROLE_CUSTOMER && n.type == 1) || (this.state.userRole != ROLE_CUSTOMER && n.credit) ? 
                                                    <div className="badge bg-success">
                                                        {this.props.settings
                                                            .constants
                                                            .CURRENCY_SYMBOL +
                                                            Number(n.return_value).toFixed(2)}

                                                            
							</div>
									: 
							 <div className="badge bg-danger">
								- {this.props.settings
									.constants
									.CURRENCY_SYMBOL +
									Number(n.amount).toFixed(2)}
						         </div>
							}
                                                </TableCell>
					
						{this.state.userRole == ROLE_CUSTOMER ? 
                                                <TableCell scope="row">
                                                    {this.props.settings
                                                        .constants
                                                        .CURRENCY_SYMBOL +
                                                        Number(n.return_value).toFixed(2)}
                                                </TableCell> : null
						}
                                                
                                                <TableCell>
                                                {this.state.userRole == ROLE_CUSTOMER ? n.heading : n.description}
                                            </TableCell>
                                                <TableCell>
                                                    {moment(
                                                        n.created_at
                                                    ).format('MM-DD-YYYY H:mm a')}
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                {emptyRows > 0 && (
                                    <TableRow
                                        style={{ height: 49 * emptyRows }}
                                    >
                                        <TableCell colSpan={5} />
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </div>
                    <TablePagination
                        className="table-pagination"
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={data.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        backIconButtonProps={{
                            'aria-label': formatMessage({
                                id: 'pagination.previous'
                            })
                        }}
                        nextIconButtonProps={{
                            'aria-label': formatMessage({
                                id: 'pagination.next'
                            })
                        }}
                        onChangePage={this.handleChangePage}
                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    />
                </div>
            </HOCLoader>
        );
    }
}

WalletList.propTypes = {
    // classes: PropTypes.object.isRequired
};
const mapStateToProps = ({ wallet, auth }) => {
    return {
        walletData: wallet.walletData,
        transactions: wallet.walletData.transactions,
        walletLoader: wallet.walletLoader,
        userData: auth.userData,
    };
};
const composedComponent = compose(
    withStyles(styles),
    connect(
        mapStateToProps,
        actions
    )
);

export default composedComponent(
    withCustomTheme(withUser(injectIntl(withRouter(WalletList))))
);



// WEBPACK FOOTER //
// ./src/components/Customer/WalletList.jsx